import { Injectable } from '@angular/core';
import { fusionViewIdSchema } from '@shared/ragai.schemas';
import { z } from 'zod';

/**
 * Navigiert zwischen Fusion-Views (eingebettete LMS-Kursseiten) (`RAGAI.FUSIONVIEW`).
 * @remarks
 * Funktioniert ausschließlich, wenn der Bot innerhalb einer Fusion-View läuft, deren Elternfenster eine
 * `openFusionView`-Funktion bereitstellt (siehe `bot/src/assets/reflact-fusion-start.js`). Außerhalb dieses
 * Kontexts (z. B. Standalone-Bot) loggt {@link goToFusionView} nur einen Konsolenfehler und tut sonst nichts.
 */
@Injectable({ providedIn: 'root' })
export class FusionviewManagerService {
  constructor() {
    console.log('FusionviewManagerService initialized');
  }

  /**
   * Navigiert zu einer anderen Fusion-View innerhalb desselben Kurses.
   * @param fusionViewId ID der Ziel-Fusion-View, oder ein Objekt gemäß `fusionViewIdSchema`.
   */
  public goToFusionView(fusionViewId: string | z.input<typeof fusionViewIdSchema>): void {
    const parsed = fusionViewIdSchema.safeParse(fusionViewId);
    if (parsed.success && typeof fusionViewId === 'object') {
      fusionViewId = parsed.data.fusionViewId;
    }
    if (window.parent.openFusionView) {
      const url = new URL(window.parent.location.href);

      window.parent.openFusionView(window.parent.location.origin + window.parent.location.pathname.replace(/\/[^/]+\/?$/, '/' + (fusionViewId as string) + '/') + url.search);
    } else {
      console.error('"goToFusionView" can only be used in fusion-view context');
    }
  }
}